import React from "react";
import { Button, Dropdown, Input } from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { BsFunnel } from "react-icons/bs";

export default function ManageJobsToolbar({
  onSearch,
  showFilterSort = true,
  activeFilterCount,
  onOpenFilters,
  sortMenu,
  sortTypeText,
}) {
  return (
    <div className="mj-controls">
      <Input
        className="mj-search-input"
        placeholder="Search job"
        prefix={<SearchOutlined className="mj-search-icon" />}
        onChange={(event) => onSearch(event.target.value)}
      />
      {showFilterSort ? (
        <div className="mj-action-btns">
          <Button
            className="mj-filter-btn"
            onClick={onOpenFilters}
            icon={<BsFunnel />}
          >
            {activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter"}
          </Button>
          <Dropdown overlay={sortMenu} trigger={["click"]}>
            <Button className="mj-sort-btn">
              {sortTypeText} <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      ) : null}
    </div>
  );
}
